import { render, staticRenderFns } from "./AppSearchModal.vue?vue&type=template&id=3b4cc0dc&scoped=true"
import script from "./AppSearchModal.vue?vue&type=script&lang=ts"
export * from "./AppSearchModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4cc0dc",
  null
  
)

export default component.exports